import type { HTMLAttributes, PropsWithChildren } from "react";

export function Card({ children, className = "", ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`rounded-2xl border border-ink-100 bg-white p-6 shadow-sm shadow-ink-900/[0.03] ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function Badge({ children, tone = "slate" }: PropsWithChildren<{ tone?: "slate" | "green" | "red" }>) {
  const tones = {
    slate: "bg-ink-50 text-ink-600",
    green: "bg-brand-50 text-brand-700",
    red: "bg-red-50 text-red-600",
  } as const;
  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${tones[tone]}`}>
      {children}
    </span>
  );
}
